import React, { Component } from 'react'
import { connect } from 'react-redux'
import { updateFillValue } from '../actions/index'

var $ = window.$

class SelectMulti extends Component {
  state = {
    value: []
  }
  componentDidMount() {
    var self = this
    $(this.$el).chosen().change(function () {
      self.setState((state) => {
        return {
          value: $(this).val() || []
        }
      })
    });
    this.props.dispatch(updateFillValue(this.state.value))
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.value !== prevState.value) {
      $(this.$el).trigger("chosen:updated");
      this.props.dispatch(updateFillValue(this.state.value))
    }
  }
  componentWillUnmount() {
    $(this.$el).chosen("destroy");
  }

  render() {
    var { answers } = this.props
    var options = answers.map((answer, index) => {
      return <option key={index} value={answer.value || answer}>{answer.text || answer}</option>
    })
    return(
      <div className="multi-select">
        <select value={this.state.value} ref={(chosen) => this.$el = chosen} data-placeholder="Select all that apply" className="chosen-select" multiple="multiple"
                name="xmp-answer" readOnly>
          { options }
        </select>
      </div>
    )
  }
}
const Container = connect(() => {return {}})(SelectMulti);

export default Container;



// WEBPACK FOOTER //
// ./src/components/SelectMulti.js